import React from "react";
import { useTranslation } from "react-i18next";
import { StyledBadge, BadgeText } from "./styles";

export enum SharedStatus {
  NOT_SHARED = "not_shared",
  PARTIALLY_SHARED = "partially_shared",
  FULLY_SHARED = "fully_shared",
}

interface SharedStatusBadgeProps {
  status: SharedStatus;
  customText?: string;
}

export const SharedStatusBadge: React.FC<SharedStatusBadgeProps> = ({ status, customText }) => {
  const { t: translate } = useTranslation();

  const getStatusText = () => {
    if (customText) return customText;

    switch (status) {
      case SharedStatus.NOT_SHARED:
        return translate("notShared");
      case SharedStatus.PARTIALLY_SHARED:
        return translate("partiallyShared");
      case SharedStatus.FULLY_SHARED:
        return translate("fullyShared");
      default:
        return translate("notShared");
    }
  };

  return (
    <StyledBadge status={status}>
      <BadgeText status={status}>{getStatusText()}</BadgeText>
    </StyledBadge>
  );
};

export const useSharedStatus = (selectedItems: string[], totalItems: string[]): SharedStatus => {
  const selectedCount = selectedItems.length;
  const totalCount = totalItems.length;

  if (selectedCount === 0) {
    return SharedStatus.NOT_SHARED;
  } else if (selectedCount === totalCount) {
    return SharedStatus.FULLY_SHARED;
  } else {
    return SharedStatus.PARTIALLY_SHARED;
  }
};
